import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { selectIsLoggedIn, selectUserLoading } from "../../store/userSlice";
import { useAuthModal } from "../../contexts/AuthModalContext";

function PrivateRoute({ children }) {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const loading = useAppSelector(selectUserLoading);
  const { openSignIn } = useAuthModal();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !isLoggedIn) {
      openSignIn();
    }
  }, [loading, isLoggedIn, openSignIn]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}

export default PrivateRoute;
